<template>
  <div class="user-info">
    <b-loading :active="loading" />
    <h1 class="user-info__title">
      個人資料
      <small>此處可以查看個人資訊。</small>
    </h1>

    <div class="user-info__content">
      <h2>我的資訊</h2>
      <div class="columns">
        <div class="column is-half-desktop is-full-mobile">
          <div class="info-card">
            <h3 class="info-card__title">基本資訊</h3>
            <div class="info-card__content">
              <b-field
                v-for="field in infoFields"
                horizontal
                :label="field.name"
                :key="`info-${field.name}`">
                {{ field.value || '&nbsp;' }}
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';

import {
  GET_USER_INFO,
} from '@/store/user/constants';
import { mapPhoneNumber } from '@/utils/helper';

export default {
  name: 'UserInfo',
  data() {
    return {
      userInfo: {},
      loading: false,
    };
  },
  computed: {
    infoFields() {
      return [
        {
          name: '人員編號',
          value: this.userInfo?.current_member?.serial || '',
        },
        {
          name: '帳號',
          value: this.userInfo?.current_member?.account || '',
        },
        {
          name: '姓名',
          value: this.userInfo?.current_member?.name || '',
        },
        {
          name: '部門',
          value: this.userInfo?.current_member?.department_name || '沒有部門',
        },
        {
          name: 'Email',
          value: this.userInfo?.current_member?.email || '',
        },
        {
          name: '分機/電話',
          value: this.userInfo?.current_member?.ext || '',
        },
        {
          name: '手機號碼',
          value: mapPhoneNumber(this.userInfo?.current_member?.phone || ''),
        },
      ];
    },
  },
  async mounted() {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.loading = true;
      await this.loadUserInfo();
    } catch (ex) {
      const errorMessage = ex?.message ? `(${ex.message})` : '';

      Toast.open({
        message: `載入個人資訊時發生錯誤，請稍後再試一次${errorMessage}`,
        type: 'is-danger',
      });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('user', {
      getUserInfo: GET_USER_INFO,
    }),
    async loadUserInfo() {
      this.userInfo = await this.getUserInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  padding: 0 100px;
  @include apply-to-tablet {
    padding: 0 2rem;
  }
  @include apply-to-phone {
    padding: 0 5px;
  }

  &__title {
    padding: 1rem 0;
    margin-bottom: 1rem;
    font-size: 1.5rem;
    font-weight: 400;
    small {
      font-size: 1rem;
      color: $dark-grey;
    }
  }
  &__content {
    padding: 1rem;
    background-color: $white;
    ::v-deep {
      & > .field {
        margin: 1rem 0;
      }
      & .field {
        &-body {
          word-break: break-all;
        }
        .label {
          font-weight: 400;
          color: $dark-grey;
        }
      }
    }
    h2 {
      font-size: 1.25rem;
      font-weight: 500;
      margin-bottom: 1rem;
    }
    ol li {
      margin: auto 1rem;
    }
  }
}

.info-card {
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  background-color: map.get($custom-colors, "light-grey-100");
  box-shadow: 0px 0px 4px 1px $lighter-grey;
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0px 0px 10px 1px $lighter-grey;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    font-weight: 500;
  }
}
</style>
